import type { CityConfig } from "../city-template/types";

export const stAlbansConfig: CityConfig = {
  city: "St. Albans",
  state: "West Virginia",
  stateAbbr: "WV",
  slug: "st-albans",
  route: "/cities/st-albans",
  title: "Emergency Passport St. Albans, WV — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in St. Albans, WV — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Kanawha County, Nitro, CRW airport, and the Kanawha River Valley.",
  h1: "Emergency & Expedited Passport Services in St. Albans, WV",
  heroSubtitle: "Charleston flight to Punta Cana in 8 days? Kanawha River cruise departing from the Gulf Coast? BridgeValley study abroad in Spain? We help St. Albans residents — from Main Street families to Nitro industrial professionals to Kanawha Valley healthcare workers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20St.%20Albans%20West%20Virginia%20historic%20Main%20Street%20along%20the%20Kanawha%20River%2C%20charming%20small-town%20downtown%20with%20brick%20storefronts%20and%20American%20flags%2C%20tree-lined%20streets%20with%20the%20river%20visible%20in%20the%20background%2C%20rolling%20green%20hills%20of%20Kanawha%20County%2C%20warm%20golden%20afternoon%20light%2C%20classic%20West%20Virginia%20river%20town%20atmosphere%20with%20railroad%20tracks%20and%20bridges&width=1800&height=700&seq=st-albans-hero-2026&orientation=landscape",
  heroImageAlt: "St. Albans West Virginia historic Main Street along the Kanawha River",
  geoPosition: "38.3856;-81.8337",
  geoPlacename: "St. Albans, West Virginia",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "211 West Fort Street, Detroit, MI 48226",
    distance: "Approximately 335 miles from St. Albans — appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "St. Albans", zips: "25177" },
    { name: "Nitro", zips: "25143" },
    { name: "Charleston", zips: "25301, 25302" },
    { name: "South Charleston", zips: "25303, 25309" },
    { name: "Dunbar", zips: "25064" },
    { name: "Cross Lanes", zips: "25313" },
    { name: "Hurricane", zips: "25526" },
    { name: "Teays Valley", zips: "25526" },
    { name: "Winfield", zips: "25213" },
    { name: "Poca", zips: "25159" },
  ],
  benefits: [
    { icon: "ri-flight-takeoff-line", title: "CRW Airport — 25 Minutes from St. Albans", desc: "Yeager Airport (CRW) is just 15 miles from St. Albans via US-60 and I-64 — about 25 minutes. Direct flights to Charlotte, Atlanta, Chicago, and DC for international connections. Quick, easy access to the Kanawha Valley's primary air hub." },
    { icon: "ri-water-flash-line", title: "Kanawha River Valley — Industry & Travel Hub", desc: "St. Albans sits directly on the Kanawha River in the heart of the chemical and manufacturing corridor. Nitro's industrial base, Charleston's state government, and South Charleston's Tech Park are all within 15 minutes — creating steady professional travel demand." },
    { icon: "ri-community-line", title: "Family-First Small City Atmosphere", desc: "St. Albans is a classic Kanawha Valley community — families, retirees, and long-time residents who value a small-town feel with big-city access. Cruise vacations, family reunions abroad, and winter getaways are common travel drivers." },
    { icon: "ri-graduation-cap-line", title: "BridgeValley & WVSU Reachable in Minutes", desc: "BridgeValley Community and Technical College's South Charleston campus and West Virginia State University in Institute are both within 15 minutes. St. Albans students attending either institution have easy access to study abroad and mission trip opportunities." },
  ],
  testimonials: [
    {
      name: "Linda R.",
      location: "St. Albans",
      rating: 5,
      text: "Retirement cruise from Miami to the Bahamas — 14 days until departure and I realized my passport was expired. They processed my renewal in 7 days. Walked onto that cruise ship with my new passport in hand. Amazing service.",
      service: "Passport Renewal — Urgent",
    },
    {
      name: "James W.",
      location: "St. Albans",
      rating: 5,
      text: "Nitro plant sent me to a chemical industry conference in Frankfurt with 12 days notice. My passport was near expiration. They handled everything — new passport in 6 days, made the CRW flight to Charlotte for my connecting flight.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "St. Albans",
      rating: 5,
      text: "Family wedding in Cancun — me, my wife, and two teenagers all needed passports. Two renewals, one new first-time passport, one name change. All four processed together and all arrived in 10 days. The whole family made the wedding.",
      service: "Multiple Passport Services",
    },
    {
      name: "Karen H.",
      location: "St. Albans",
      rating: 5,
      text: "BridgeValley nursing study abroad to Costa Rica. I procrastinated on the passport and had 3 weeks until departure. They walked me through everything — acceptance visit at Charleston post office, overnight shipping, and my passport arrived with 4 days to spare.",
      service: "New Passport — Expedited",
    },
  ],
  facilities: [
    {
      id: "st-albans-1",
      name: "St. Albans Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "431 5th Ave",
      city: "St. Albans",
      state: "WV",
      zip: "25177",
      phone: "(304) 727-7263",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "St. Albans — 5th Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for St. Albans residents. Convenient Main Street-area location. Limited afternoon hours — book appointments early. Passport photos not always available — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "st-albans-2",
      name: "Nitro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4209 1st Ave",
      city: "Nitro",
      state: "WV",
      zip: "25143",
      phone: "(304) 755-0563",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "Nitro — 3 miles east, Kanawha County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Closest alternative facility for eastern St. Albans and Jefferson area residents. About 5 minutes via US-60. Often has good appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "st-albans-3",
      name: "Charleston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1002 Lee St E",
      city: "Charleston",
      state: "WV",
      zip: "25301",
      phone: "(304) 347-5421",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Charleston — 12 miles east, Kanawha County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest facility in the region with most appointment availability and passport photo services on-site. About 20 minutes from St. Albans via I-64. Best option for combining photo and acceptance visit in one trip.",
      icon: "ri-mail-line",
    },
    {
      id: "st-albans-4",
      name: "Kanawha County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "409 Virginia St E, Room 202",
      city: "Charleston",
      state: "WV",
      zip: "25301",
      phone: "(304) 357-0440",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      distance: "Downtown Charleston — Kanawha County Courthouse",
      website: "https://www.kanawha.us/circuit-clerk",
      websiteLabel: "Kanawha County Circuit Clerk",
      notes: "County clerk acceptance counter. Often less crowded than post offices. No photo services on-site. Convenient for St. Albans residents who work in downtown Charleston.",
      icon: "ri-government-line",
    },
    {
      id: "st-albans-5",
      name: "Cross Lanes Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5480 Big Tyler Rd",
      city: "Cross Lanes",
      state: "WV",
      zip: "25313",
      phone: "(304) 776-1407",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Cross Lanes — 10 miles northeast, Kanawha County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Alternative facility for northern St. Albans area residents. Convenient for those near the Cross Lanes border. About 15 minutes via surface roads.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "How fast can I get a passport in St. Albans?", a: "We offer St. Albans-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest passport agency is in Detroit (335 miles) — courier service is the faster and far more practical option for Kanawha Valley residents." },
    { q: "Do I need to visit an office in St. Albans?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (St. Albans Post Office, Nitro Post Office, or Charleston Main Post Office), then ship documents overnight. We handle the State Department submission and return your passport to your St. Albans address." },
    { q: "Which airport should St. Albans travelers use?", a: "Yeager Airport (CRW) in Charleston is the primary airport — about 15 miles from St. Albans (25 minutes). CRW offers direct flights to Charlotte, Atlanta, Chicago, and DC for international connections. Columbus (CMH) is about 2 hours away for more international route options." },
    { q: "Can I use Nitro or Charleston acceptance facilities?", a: "Yes — many St. Albans residents use the Nitro Post Office (3 miles east) or Charleston Main Post Office (12 miles east). Both are fully valid options. Charleston Main Post Office offers the best appointment availability and has passport photo services on-site." },
    { q: "What is the best price for expedited passport service in St. Albans?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. Best price guarantee included." },
    { q: "Where can I get passport photos in St. Albans?", a: "Walgreens on MacCorkle Avenue in South Charleston (10 minutes), CVS Pharmacy on D Street in South Charleston, and Walmart Supercenter in South Charleston all offer passport photos. The Charleston Main Post Office also provides photo services. The St. Albans Post Office may not always have photos available — call ahead." },
    { q: "How do BridgeValley and WVSU students from St. Albans handle passports?", a: "St. Albans students attending BridgeValley CTC or West Virginia State University (both within 15 minutes): start your passport application when you apply to a study abroad program — not when you're accepted. Acceptance-to-departure windows are often only 4–6 weeks. We provide student-specific guidance." },
    { q: "What about the Kanawha River industry travel demand?", a: "The Nitro-St. Albans corridor is part of West Virginia's chemical and manufacturing heartland. Industrial conferences, supplier meetings, and international plant tours generate steady passport demand. Professional travel authorizations often come 7–14 days before departure — we handle short-notice processing." },
    { q: "How do I check my passport status from St. Albans?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online status system. Processing from submission to return typically matches your chosen speed tier." },
    { q: "Can I get same-day passport service in St. Albans?", a: "Same-day service is available for life-or-death emergencies through the Detroit Passport Agency (335 miles, 5+ hour drive each way, appointment required). For non-emergency situations, our fastest courier service begins at 24 hours — far more practical for Kanawha Valley residents." },
  ],
  photoLocations: [
    { name: "Walgreens — MacCorkle Ave (South Charleston)", address: "5060 MacCorkle Ave, South Charleston, WV 25309", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS Pharmacy — D Street (South Charleston)", address: "412 D St, South Charleston, WV 25303", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart Supercenter — South Charleston", address: "2700 Mountaineer Blvd, South Charleston, WV 25309", hours: "Daily 6 AM – 11 PM" },
    { name: "Charleston Main Post Office", address: "1002 Lee St E, Charleston, WV 25301", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Kanawha Blvd (Charleston)", address: "4000 Kanawha Blvd E, Charleston, WV 25301", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "WV DMV — Charleston Regional Office",
      address: "5707 MacCorkle Ave SE, Charleston, WV 25304",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, state ID cards. Located on MacCorkle Avenue about 15 minutes from St. Albans. Appointment recommended.",
      featured: true,
    },
  ],
  dmvWebsite: "https://transportation.wv.gov/dmv/",
  dmvLabel: "West Virginia DMV — Official Website",
  airports: [
    {
      code: "CRW",
      name: "West Virginia International Yeager Airport",
      distance: "About 15 miles east of St. Albans via I-64",
      address: "100 Airport Rd, Charleston, WV 25311",
      note: "Primary airport for Kanawha Valley travelers. Direct flights to Charlotte (CLT), Atlanta (ATL), Chicago (ORD), and Washington Dulles (IAD) for international connections. About 25 minutes from St. Albans.",
      flightUrl: "https://yeagerairport.com/",
      flightLabel: "Yeager Airport Website",
      featured: true,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "About 150 miles northwest of St. Albans via I-77",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Second option for more direct international routes. Direct flights to Toronto, Cancun, and Caribbean destinations. About 2.5 hours via I-77.",
      flightUrl: "https://flycolumbus.com/",
      flightLabel: "Columbus Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate — WV DHHR",
      desc: "Request certified birth certificates from the West Virginia DHHR Vital Registration Office in Charleston.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate — Kanawha County",
      desc: "Request marriage license records from the Kanawha County Clerk for name changes and passport applications.",
      url: "https://www.kanawha.us/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree — Kanawha County",
      desc: "Obtain certified divorce records through the Kanawha County Circuit Clerk for name change passport corrections.",
      url: "https://www.kanawha.us/circuit-clerk",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate — WV DHHR",
      desc: "Certified death certificates through WV DHHR for estate and legal matters.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "CRW flight to Cancun in two days? Industrial conference with short notice? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help St. Albans residents renew fast — no agency visit required. Perfect for Kanawha River Valley families and retirees.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport — First Time",
      description: "First-time applicants require an in-person acceptance visit. We guide St. Albans residents through every step with clear instructions.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional documentation. We guide you through everything to avoid costly mistakes.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear checklists.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Kanawha Valley business and industrial professionals.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Kanawha Valley travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size travel document for land and sea crossings to Canada, Mexico, Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport St. Albans WV", description: "Urgent passport processing for St. Albans West Virginia travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal St. Albans WV", description: "Fast passport renewal for St. Albans West Virginia residents." },
    { name: "First-Time Passport St. Albans WV", description: "New passport application services for St. Albans West Virginia residents." },
    { name: "Child Passport St. Albans WV", description: "Minor passport services for St. Albans West Virginia families." },
    { name: "Name Change Passport St. Albans WV", description: "Passport name correction for St. Albans residents." },
    { name: "Second Passport St. Albans WV", description: "Second passport services for St. Albans business and frequent travelers." },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long Before a Cruise or Family Vacation",
      description: "St. Albans families booking winter cruises and spring break trips often wait until 2–3 weeks before departure to check passports. Standard processing is 6–8 weeks. Start passport work the moment you book international travel — not when you start packing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming the St. Albans Post Office Has Photo Services",
      description: "Not all small-town post offices offer passport photo services. The St. Albans Post Office may not have photos available on any given day. Get photos at Walgreens or CVS in South Charleston before your acceptance appointment to avoid a wasted visit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Nitro Industrial Travel — Short-Notice Scramble",
      description: "Industrial professionals in the Nitro-St. Albans corridor get conference and supplier meeting notices with 7–14 days notice. Standard passport processing is 6–8 weeks. Maintain a current passport — don't let an expired passport block a career opportunity.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Photos from local pharmacies and big-box stores frequently fail State Department standards. We review all photos before submission to prevent rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Thinking Detroit Agency Appointments Are Practical",
      description: "The Detroit Passport Agency is 335 miles away. That's a 5+ hour drive each way — essentially a two-day trip. Agency appointments are booked 2+ weeks out and primarily serve life-or-death emergencies. Our courier service handles everything remotely.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order — just a few minutes from your St. Albans home." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your departure airport — CRW or Columbus." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most St. Albans clients use the UPS Store in South Charleston or Charleston." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency channel — faster than a Detroit agency appointment, no 335-mile drive required." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives at your St. Albans address within your selected timeframe. No long drive, no appointment scramble." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — nearest is Detroit (335 miles)", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review", "No dedicated agent", "Updates only by mail", "Can't upgrade speed after submission"],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Detroit agency is 335 miles away. Booked 2+ weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 335-mile drive to Detroit", fpc: "Most St. Albans travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission" },
    { feature: "Local Guidance", agency: "Generic — no Kanawha County or CRW expertise", fpc: "Full St. Albans/Kanawha Valley knowledge" },
    { feature: "Cost vs Resellers", agency: "Government fees only — you handle all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Fast passport services in Charleston, WV", route: "/cities/charleston" },
    { name: "Expedited passport in South Charleston, WV", route: "/cities/south-charleston" },
    { name: "Quick passport services in Huntington, WV", route: "/cities/huntington" },
    { name: "Urgent passport services in Nitro, WV area", route: "/cities/charleston" },
    { name: "West Virginia passport services overview", route: "/states/west-virginia" },
  ],
  fpcOfficeAddress: "1629 K Street, Suite 300, Washington, DC 20006",
  fpcOfficeNote: "Fast Passport Center serves St. Albans via secure registered courier with direct access to regional passport agencies. Our registered couriers hand-deliver your documents — meaning you get faster results without the 335-mile Detroit drive. St. Albans residents can ship from any UPS Store, FedEx Office, or post office in the Kanawha Valley.",
  fpcOfficeDistance: "Serving St. Albans, Nitro, Charleston, South Charleston, Dunbar, Cross Lanes, and all Kanawha County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout St. Albans and the Kanawha River Valley. From Main Street to the Nitro border, from the riverfront to the hilltop neighborhoods — we serve all St. Albans residents. Our courier service provides faster processing than a Detroit agency appointment.",
  nearbyCitiesIntro: "We serve St. Albans and all Kanawha Valley communities including Nitro, Charleston, South Charleston, Dunbar, Cross Lanes, Hurricane, Teays Valley, Winfield, and Poca. Travelers depart from Yeager Airport (CRW) and Columbus (CMH).",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in St. Albans as simple and predictable as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you.",
  mistakesIntro: "St. Albans travelers encounter unique passport issues — from cruise booking timing gaps to Kanawha River Valley industrial travel deadlines to small-town acceptance facility limitations. Here are the most common mistakes we see.",
  testimonialsIntro: "St. Albans travelers — from Nitro industrial professionals and BridgeValley students to Kanawha Valley families and retirees — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in St. Albans, WV? Here are the most common ones from Kanawha River Valley travelers.",
  statePageRoute: "/states/west-virginia",
  statePageName: "West Virginia",
  servicesIntro: "Whether you need a renewal before a CRW flight to Punta Cana, an emergency passport for an industrial conference, or a first-time passport for a family cruise — Fast Passport Center handles it with reserved courier submission. As a registered State Department courier, we guarantee the best price.",
  travelTiming: {
    title: "Travel & Passport Timing for St. Albans Residents",
    intro: "St. Albans' Kanawha River Valley location with CRW access and family-oriented travel patterns creates distinct passport needs.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "CRW — Yeager Airport",
        subtitle: "15 miles east via I-64, primary regional gateway",
        description: "Yeager Airport serves as the primary airport for St. Albans travelers with direct flights to Charlotte, Atlanta, Chicago, and Washington DC for international connections. The drive takes about 25 minutes — straight shot down US-60 to I-64. CRW is small and efficient — minimal security lines compared to larger airports.",
        tip: "CRW's unique mountaintop runway means fog delays are possible in fall and winter mornings. For international connections via Charlotte or Atlanta, book late morning departures from CRW to avoid fog and give yourself comfortable connection time.",
      },
      {
        icon: "ri-ship-line",
        title: "Cruise & Family Vacation Travel",
        subtitle: "The dominant St. Albans international travel pattern",
        description: "St. Albans is a classic Kanawha Valley family community — cruise vacations, resort trips, and family reunions drive the majority of international travel. Caribbean cruises from Miami/Fort Lauderdale, Mexico resort vacations, and European family heritage trips are the most common.",
        tip: "Cruise lines require passports valid for 6+ months beyond your return date. Start passport work the day you book the cruise — not when final payment is due. Standard processing (6–8 weeks) should ideally be complete before your final payment date.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Kanawha Valley Location = CRW Gateway, Detroit Distance",
      description: "St. Albans' Kanawha Valley position means 25-minute access to CRW for regional connections and 2.5-hour access to Columbus for more international routes. Our courier service provides faster passport processing without the 335-mile Detroit drive.",
    },
  },
  destinations: {
    title: "Where St. Albans Travelers Go",
    intro: "St. Albans' Kanawha River Valley location, family-oriented community, and proximity to industrial Nitro create distinct international travel patterns.",
    stats: [
      { stat: "50%", label: "of St. Albans expedited requests are family vacation or cruise-related" },
      { stat: "25%", label: "are industrial and professional travel from the Nitro-St. Albans corridor" },
      { stat: "CRW", label: "dominant airport for 80%+ of Kanawha Valley international departures" },
      { stat: "7 Days", label: "shortest turnaround for a St. Albans retirement cruise traveler" },
    ],
    destinations: [
      { name: "Mexico & Caribbean", context: "CRW connecting flights, family resort vacations, cruises from Miami/Fort Lauderdale", urgency: "Cruise bookings locked 60–90 days out; resort vacations peak in winter", icon: "ri-map-pin-2-line" },
      { name: "Bahamas & Bermuda", context: "Retirement cruises, family reunions, spring break getaways", urgency: "Cruise final payment dates typically 75–90 days before sailing", icon: "ri-map-pin-2-line" },
      { name: "Germany & United Kingdom", context: "Nitro industrial conferences, chemical industry travel, European family heritage trips", urgency: "Professional travel authorizations 7–14 days before departure", icon: "ri-map-pin-2-line" },
      { name: "Costa Rica & Central America", context: "BridgeValley study abroad, mission trips, eco-tourism", urgency: "Study abroad acceptance 4–6 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Italy & Spain", context: "BridgeValley & WVSU study abroad, retirement heritage travel", urgency: "Program dates fixed 6–12 weeks in advance", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Industrial supply chain meetings, family visits, Niagara Falls tourism", urgency: "Meeting dates often 1–2 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other West Virginia Service Areas",
    crossLinksDesc: "We serve travelers across the Mountain State.",
    crossLinks: [
      { name: "Charleston", route: "/cities/charleston" },
      { name: "Huntington", route: "/cities/huntington" },
    ],
  },
};